

document.addEventListener("DOMContentLoaded", () => {

  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white', // white-icon will appear
    applyToParents: true,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });

  document.querySelector(".mv_textBox").classList.add("scrollin");
  document.querySelector(".mv").classList.add("scrollin");

  document.querySelectorAll(".typeTab_area .tab").forEach(tab => {
    tab.addEventListener("click", function () {

      // すべてのタブから active を外す
      document.querySelectorAll(".typeTab_area .tab").forEach(t => {
        t.classList.remove("active");
      });

      // クリックされたタブに active を付与
      this.classList.add("active");

      // クリックした要素の ID を取得
      const id = this.id;

      // 対象要素から active を外す
      [
        ".tab-content_lifeinfo"
      ].forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.classList.remove("active");
        });
      });

      // ID と同じクラスを持つ要素に active を付与
      document.querySelectorAll("." + id).forEach(el => {
        el.classList.add("active");
      });

    });
  });

  // 画像パララックス
  gsap.registerPlugin(ScrollTrigger);
  const items = gsap.utils.toArray(".js-trigger");
  items.forEach((item) => {
    const imgs = item.querySelectorAll("img");
    imgs.forEach((img) => {
      gsap.fromTo(
        img,
        { yPercent: 0 },
        {
          yPercent: -20,// 上に要素の幅の1/5分移動
          ease: "none",
          scrollTrigger: {
            trigger: item,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
          },
        }
      );
    });
  });

  // 1. セレクタを修正（href^="#" にすることでハッシュリンクのみを対象にする）
  const smoothScrollLinks = document.querySelectorAll('a[href^="#"]');

  // ヘッダーの高さを考慮する場合、ここでヘッダー要素を取得しておく
  const header = document.querySelector('header'); // もしクラス名なら '.your-header-class'

  smoothScrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');

      // 2. hrefが"#"のみ、または空の場合はトップへ、それ以外は要素を探す
      const target = (href === '#' || href === '')
        ? document.documentElement
        : document.querySelector(href);

      if (!target) return;

      // デフォルトの挙動をキャンセル
      e.preventDefault();

      // 3. ヘッダーの高さを取得（headerが存在しない場合は0）
      const headerHeight = header ? header.offsetHeight : 0;

      // 4. スクロール位置の計算
      // 現在のスクロール量 + 要素のブラウザ上端からの距離 - ヘッダーの高さ
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: position,
        behavior: 'smooth',
      });
    });
  });

  document.querySelectorAll('.type_item').forEach(item => {
    item.addEventListener('click', function () {
      // 1. クリックされた要素のクラス名から 'select' で始まるものを取得
      const targetClass = Array.from(this.classList).find(cls => cls.startsWith('select'));

      if (targetClass) {
        // 2. 以前の active クラスをすべて削除
        document.querySelectorAll('.active').forEach(el => {
          el.classList.remove('active');
        });

        // 3. 同じ selectX クラスを持つすべての要素に active を一斉付与
        document.querySelectorAll('.' + targetClass).forEach(el => {
          el.classList.add('active');
        });
      }
    });
  });


});
